var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 26L19.5 26M45.5 13L19.5 13M45.5 39L19.5 39",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 28.1663C9.86328 28.1663 10.8333 27.1963 10.8333 25.9997C10.8333 24.8031 9.86328 23.833 8.66667 23.833C7.47005 23.833 6.5 24.8031 6.5 25.9997C6.5 27.1963 7.47005 28.1663 8.66667 28.1663Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 15.1663C9.86328 15.1663 10.8333 14.1963 10.8333 12.9997C10.8333 11.8031 9.86328 10.833 8.66667 10.833C7.47005 10.833 6.5 11.8031 6.5 12.9997C6.5 14.1963 7.47005 15.1663 8.66667 15.1663Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 41.1663C9.86328 41.1663 10.8333 40.1963 10.8333 38.9997C10.8333 37.8031 9.86328 36.833 8.66667 36.833C7.47005 36.833 6.5 37.8031 6.5 38.9997C6.5 40.1963 7.47005 41.1663 8.66667 41.1663Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/IconList.b95afb289582769c124b9bcde128c8e9.svg";
export { ForwardRef as ReactComponent };